// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'

// =============================================================================
// Vue Plugins
// =============================================================================

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueCl from 'vue-cl';
import VueForms from 'vue-forms';
import VueCore from 'vue-core';
import VueChat from 'vue-chat';
import VueCloud from 'vue-cloud';

Vue.use(VueCl)
Vue.use(VueForms)
Vue.use(VueCore)
Vue.use(VueChat);
Vue.use(VueCloud);

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts)

// =============================================================================
// Vue Components
// =============================================================================

import AppComponents from 'app/components';

for (let k in AppComponents) {
  Vue.component(k, AppComponents[k]);
}

// =============================================================================
// Services configuration
// =============================================================================

import UserService from 'vue-core/services/UserService';
import Notifier from 'vue-core/services/NotificationService';
import env from 'environment';

UserService.configure({
  login: {
    url: env.baseUrl + '/login',
    contentType: 'application/x-www-form-urlencoded'
  },

  logout: {
    url: env.baseUrl + '/logout'
  },

  ping: {
    url: env.baseUrl + '/users/ping'
  },

  changePassword: {
    url: env.baseUrl + '/users/password'
  },
});

Notifier.configure({
  url: env.baseUrl + '/socket'
});

// =============================================================================
// Application-wide events
// =============================================================================

import EventBus from 'core/EventBus';
import HttpInterceptor from 'vue-core/auth/HttpInterceptor';

EventBus.subscribe('PreAuthenticationEvent', () => {
  HttpInterceptor.clear();
});

EventBus.subscribe('AuthenticationSuccessEvent', (data) => {
  HttpInterceptor.setup(data);
});

EventBus.subscribe('LogoutSuccessEvent', (data) => {
  HttpInterceptor.clear();
})

// =============================================================================

import { i18n, setupI18n } from 'vue-core/i18n';

setupI18n({
  dateFormat: 'dd/mm/yyyy',
  language: 'it'
});

import App from './App';
import router from './router';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  }
})
